import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addEnv, updateEnv } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew } from "@/mixins/index";
export default {
  mixins: [gmToolNew],
  data: function data() {
    return {
      dialogFormVisible: false,
      paramsData: {
        env_name: "",
        env_flag: "",
        env_gm_url: "",
        id: "",
        game_ids: [],
        pass_key: ''
      },
      gameList: [],
      rules: {
        env_name: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        env_flag: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        env_gm_url: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        game_ids: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        pass_key: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getGameList();

                if (data.id) {
                  data.game_ids = data.game_ids && data.game_ids.split(",").map(Number);
                  _this.paramsData = _objectSpread({}, data);
                }

                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getGameList: function getGameList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("d2admin/game/GameList", {
                  page_size: 1000
                });

              case 2:
                query = _context2.sent;
                _this2.gameList = query.data || [];

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.paramsData = {
        env_name: "",
        env_flag: "",
        env_gm_url: "",
        id: '',
        game_ids: [],
        pass_key: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(vali) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (vali) {
                    reqFn = _this3.paramsData.id ? updateEnv : addEnv;
                    _this3.paramsData.game_ids = _this3.paramsData.game_ids.join(",");
                    reqFn(_objectSpread(_objectSpread({}, _this3.paramsData), {}, {
                      game_id: _this3.rawData.game_id
                    })).then(function (res) {
                      if (res.status == 200) {
                        Message.success(_this3.$t('operationSuccess'));
                        _this3.dialogFormVisible = false;

                        _this3.$emit("change");
                      }
                    });
                  }

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};